import { useIntlDateFormatter } from 'lib/datetime/dateUtils'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import { LOYALTY_PURCHASE_POINTS_MAX_PER_WINDOW } from 'loyalty/constants/loyaltyPurchasePoints'
import { useDecimalFormatter } from 'hooks/useNumberFormatters'
import { useIntl } from 'react-intl'

interface Props {
  /** ISO date — when the rolling-window cap clears for this offer. */
  nextEligiblePurchaseDate?: string
}

function LoyaltyPurchasePointsCapReachedBanner(props: Props) {
  const { nextEligiblePurchaseDate } = props
  const intl = useIntl()
  const formatDate = useIntlDateFormatter()
  const formatDecimal = useDecimalFormatter()

  const maxPoints = formatDecimal(LOYALTY_PURCHASE_POINTS_MAX_PER_WINDOW)

  const message = nextEligiblePurchaseDate
    ? intl.formatMessage(
        {
          id: '2arna-jb4v92dmX4zPvH',
          defaultMessage: 'You’ve reached the maximum of {maxPoints} points purchasable in a 12-month period. You’ll be eligible to purchase again on {date}.',
          description: 'Body copy shown when the member has hit the rolling-window buy-points cap, with the next eligible date',
        },
        {
          maxPoints,
          date: formatDate(new Date(nextEligiblePurchaseDate), { day: 'numeric', month: 'long', year: 'numeric' }),
        },
      )
    : intl.formatMessage(
        {
          id: '_cIIhn0f1RFFpMsUqseM',
          defaultMessage: 'You’ve reached the maximum of {maxPoints} points purchasable in a 12-month period.',
          description: 'Body copy shown when the member has hit the rolling-window buy-points cap and no specific reset date is available',
        },
        { maxPoints },
      )

  return <MessageBanner kind="warning" align="start" icon={<LineInfoCircleIcon />}>
    {message}
  </MessageBanner>
}

export default LoyaltyPurchasePointsCapReachedBanner
